import { Component, Input, OnInit, Optional } from '@angular/core';
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogRef } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-with-checkbox-option',
  standalone: true,
  imports: [
    NbCardModule,
    NbButtonModule,
    NbCheckboxModule,
    TranslateModule
  ],
  templateUrl: './dialog-with-checkbox-option.component.html',
  styleUrl: './dialog-with-checkbox-option.component.scss'
})
export class DialogWithCheckboxOptionComponent implements OnInit {

  @Input() public canCancel: boolean = true;
  @Input() public option: string = "";
  public title: string = '';
  public content: string = '';
  private checked: boolean = false;

  constructor(
    @Optional() public ref: NbDialogRef<DialogWithCheckboxOptionComponent>
  ) { }

  public ngOnInit(): void {
  }

  public checkedChange() {
    this.checked = !this.checked;
  }

  public close(confirmation: boolean = false): void {
    const data = {
      confirmation: confirmation,
      checked: this.option ? this.checked : null
    }
    if (this.ref) {
      this.ref.close(data);
    }
  }
}
